import { useQuery } from '@tanstack/react-query'
import { Puzzle } from 'lucide-react'
import { fetchApi, OrzForgeApiError } from '../lib/api'
import type { McpToolList } from '../types'

export function McpPage() {
  const query = useQuery<McpToolList>({
    queryKey: ['mcp-tools'],
    queryFn: async () => (await fetchApi('/mcp/tools')) as McpToolList,
    staleTime: 300_000,
  })

  if (query.isLoading) {
    return (
      <div className="flex h-96 items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-500 border-t-transparent" />
      </div>
    )
  }

  if (query.error) {
    return (
      <div className="rounded-xl border border-red-500/20 bg-red-500/10 p-6 text-red-300">
        Error cargando MCP:{' '}
        {query.error instanceof OrzForgeApiError ? query.error.message : 'Error desconocido'}
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-bold">Catálogo MCP</h1>
        <p className="text-sm text-gray-400">
          Herramientas expuestas para agentes compatibles con Model Context Protocol.
        </p>
      </header>

      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {query.data?.tools.map((tool) => (
          <div
            key={tool.name}
            className="flex flex-col rounded-xl border border-white/10 bg-panel p-5"
          >
            <div className="mb-3 flex items-center gap-3">
              <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-brand-500/10 text-brand-400">
                <Puzzle className="h-5 w-5" />
              </div>
              <h3 className="font-mono text-sm font-semibold text-brand-300">{tool.name}</h3>
            </div>
            <p className="mb-4 flex-1 text-sm text-gray-400">{tool.description}</p>
            <details className="text-xs">
              <summary className="cursor-pointer text-gray-500 hover:text-gray-300">
                Ver input_schema
              </summary>
              <pre className="mt-2 max-h-48 overflow-auto rounded-lg bg-surface p-3 font-mono text-gray-400">
                {JSON.stringify(tool.input_schema, null, 2)}
              </pre>
            </details>
          </div>
        ))}
      </div>
    </div>
  )
}
